import { createContext } from 'react';

export const StepperContexts = createContext(null);
